import { Card } from "@/components/ui/card";
import justMacGarageLogo from "@/assets/just-mac-garage-logo.webp";
import tiagoThumbnail from "@/assets/tiago-thumbnail.webp";
import {
  Attribution,
  CountUp,
  QuoteCard,
  useInViewRef,
} from "./testimonial/shared";
import { ShopifyDashboardVisual } from "./testimonial/ShopifyDashboardVisual";

export function TestimonialFeatureSection() {
  const { ref, inView } = useInViewRef<HTMLElement>();

  return (
    <section ref={ref} className="bg-background pt-8 pb-12 sm:pt-12 sm:pb-16">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2 lg:gap-16">

          {/* Left: headline + quote + attribution */}
          <div className="flex flex-col">
            <h2 className="text-4xl font-bold tracking-tight text-foreground">
              Shopify store<span className="hidden sm:inline"> sales increased by</span>
              <span className="sm:hidden"><br />sales increased by</span>
              <br />

              <span className="inline-block whitespace-nowrap py-3 text-5xl sm:text-6xl lg:text-7xl tabular-nums">
                <span className="text-gradient-cycle font-bold">
                  <CountUp target={150} start={inView} suffix="%" />
                </span>{" "}
                <span className="text-3xl sm:text-4xl lg:text-5xl">in</span>{" "}
                <span className="text-gradient-cycle font-bold">
                  <CountUp target={90} start={inView} /> days
                </span>
              </span>
            </h2>

            <QuoteCard>
              The new site looks much better, but more importantly it started
              making sales <span className="text-gradient-cycle font-bold">fast.</span>
            </QuoteCard>

            <Attribution
              avatarSrc={tiagoThumbnail}
              avatarAlt="Tiago Sousa"
              name="Tiago Sousa"
              role="Owner, Just Mac Garage"
              logoSrc={justMacGarageLogo}
              logoAlt="Just Mac Garage logo"
            />
          </div>

          {/* Right: Animated Shopify dashboard */}
          <Card className="relative mx-auto w-full border-border/60 bg-card/60 p-0 backdrop-blur">
            <div className="relative w-full">
              <ShopifyDashboardVisual />
            </div>
          </Card>
        </div>
      </div>
    </section>
  );
}
